import { api } from './client';

/** Estado do import do acervo (Data Lake → processos e clientes, sem baixar documentos). */
export interface AcervoImportProgress {
  status: 'PENDING' | 'RUNNING' | 'COMPLETED' | 'FAILED' | 'CANCELLED' | 'idle';
  job_id?: string;
  /** manual (botão), conexao_pdpj/qrcode_totp/certificado, djen_inicial, semanal. */
  fonte?: string | null;
  total_estimado?: number;
  processados?: number;
  criados?: number;
  atualizados?: number;
  descartados_encerrados?: number;
  descartados_sem_representacao?: number;
  cortados_pelo_plano?: number;
  excluidos_pelo_usuario?: number;
  clientes_criados?: number;
  clientes_vinculados?: number;
  error?: string;
}

export async function importarAcervo(): Promise<{ status: string }> {
  const { data } = await api.post<{ status: string }>('/processos/acervo/importar');
  return data;
}

export async function cancelarImportacaoAcervo(): Promise<{ status: string }> {
  const { data } = await api.post<{ status: string }>('/processos/acervo/cancelar');
  return data;
}

export async function fetchAcervoStatus(): Promise<AcervoImportProgress> {
  const { data } = await api.get<AcervoImportProgress>('/processos/acervo/status');
  return data;
}
